import { CircleAlert } from 'lucide-react';
import { useJobContext } from 'pages/Job/context';

const QuoteChangesRequested: React.FunctionComponent = function () {
  const { companyName } = useJobContext();
  return (
    <div className="flex flex-row gap-x-2 p-3 md:p-4 bg-orange-100 border-2 border-orange-200 rounded-xl">
      <CircleAlert className="text-orange-200 min-w-6" size={24} />
      <div className="flex flex-col gap-y-1">
        <h1 className="text-16-24-em">Change Request Submitted</h1>
        <h2 className="text-12-18-b md:text-14-22-b">
          Your change request has been sent to {companyName}. Any changes they
          make to your quote will be automatically shown here.
        </h2>
      </div>
    </div>
  );
};

export default QuoteChangesRequested;
